import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useEditorStore } from '~/shell/Store';
import { Tooltip } from '~/ui/tooltip/Tooltip';
import { Button } from '~/ui/buttons';
import { CloseButton } from '~/ui/buttons/CloseButton';

const TooltipContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9999;

  b {
    font-family: ralewayBold;
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }

  .tooltip-container {
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-width: 427px;
  }

  .closeBtn {
    position: absolute;
    top: 10px;
    left: 100%;
    margin-left: -34px;
  }

  button {
    font-family: ralewayBold;
    font-size: 14px;
  }
`;

const Tooltips = () => {
  const { showTooltips, tooltip, nextTooltip, prevTooltip, setShowTooltips } =
    useEditorStore();

  useEffect(() => {
    if (window && window.document) {
      setTimeout(() => {
        const element = window.document.getElementById('tooltip-title');
        if (element) {
          element.focus();
        }
      }, 0);
    }
  }, [tooltip]);

  const tooltipList = [
    {
      title:
        'Browse your course outline here, organized into chapters and slides. Simply click any slide to view its content. Need to reorganize? Just drag and drop slides to create your perfect learning sequence.',
      position: {
        left: '255px',
        top: '100px'
      },
      arrow: 'left'
    },
    {
      title:
        'Click to add new slides or chapters. Choose from various templates with images, videos, or interactive quizzes.',
      position: {
        left: '255px',
        top: '16px'
      },
      arrow: 'left'
    },
    {
      title:
        'Click this Edit icon to open the Media modal, where you can select and change background images, or videos.',
      position: {
        right: '5px',
        top: '125px'
      },
      arrow: 'top-right'
    },
    {
      title:
        'Bring your slide to life with voice. Upload audio files, or generate speech from text using our natural-sounding AI voices.',
      position: {
        right: '295px',
        top: '75px'
      },
      arrow: 'top-right'
    },
    {
      title:
        'Once you are done editing, publish the course here, and assign it to your Learners.',
      position: {
        right: '50px',
        top: '75px'
      },
      arrow: 'top-right'
    }
  ];

  if (!showTooltips) return null;

  return (
    <TooltipContainer>
      <Tooltip
        placement={tooltipList[tooltip].arrow}
        top={tooltipList[tooltip].position.top}
        left={tooltipList[tooltip].position.left}
        right={tooltipList[tooltip].position.right}
        className="tooltip-container"
      >
        <CloseButton
          type="close"
          onClick={() => setShowTooltips(false)}
          autoFocus={false}
        />
        <b id="tooltip-title" tabIndex={0} role="heading" aria-level={2}>
          Tooltip {tooltip + 1}/5
        </b>
        <span>{tooltipList[tooltip].title}</span>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'left' }}>
          {tooltip > 0 && (
            <Button
              onClick={prevTooltip}
              style={{
                backgroundColor: 'var(--color-yellow-lt)',
                color: 'var(--color-accent-dk)',
                border: '2px solid var(--color-accent-dk)'
              }}
            >
              Previous
            </Button>
          )}
          {tooltip < 4 && (
            <Button onClick={nextTooltip} tabIndex={0}>
              Next
            </Button>
          )}
          {tooltip === 4 && (
            <Button onClick={() => setShowTooltips(false)} tabIndex={0}>
              Got it
            </Button>
          )}
        </div>
      </Tooltip>
    </TooltipContainer>
  );
};

export default Tooltips;
